import {APP_INITIALIZER, Component, Directive, Inject, Injector, LOCALE_ID, NgModule, Optional, Pipe} from '@angular/core';


import {AppComponent} from './app.component';
import {ListComponent} from './video/list/list.component';
import {AppRoutingModule} from './app-routing.module';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser';
import {ServiceProxiesModule} from '../shared/service-proxies/service-proxies.module';
import {Headers, Http, HttpModule, Response} from '@angular/http';
import {CategoryComponent} from './video/list/category.component';
import {ShowComponent} from './video/list/show.component';
import {AppConsts} from '../assets/AppConsts';
import {API_BASE_URL} from '../shared/service-proxies/service-proxies';
import 'rxjs/add/operator/finally';

export function appInitializerFactory() {
  return () => {
    return AppModule.getApplicationConfig();
    // return new Promise<boolean>(() => {
    // });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    ListComponent,
    ShowComponent,
    CategoryComponent
  ],
  imports: [
    BrowserModule,
    ServiceProxiesModule,
    HttpModule,
    AppRoutingModule,
    AppConsts
  ],
  providers: [
    AppConsts,
    {provide: API_BASE_URL, useFactory: AppModule.getappBaseUrl},
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  private static http: Http;
  private static appBaseUrl: string;

  constructor(http: Http) {
    AppModule.http = http;
  }

  static getappBaseUrl(): string {
    return AppConsts.appBaseUrl;
  }
  static getApplicationConfig() {
    const promise = AppModule.http.get('assets/config.json').map(data => data.json()).toPromise();
    promise.then(config => {
        AppConsts.appBaseUrl = config.appBaseUrl;
        AppConsts.imageBaseUrl = config.imageBaseUrl;
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts